import React, { PropsWithChildren, memo } from 'react';

type Props = {
  style?: React.CSSProperties;
} & PropsWithChildren;

// rounded corner flex container
export const Card = memo((props: Props) => {
  const { children, style } = props;

  const cardStyle: React.CSSProperties = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '16px 8px',
    gap: '0.25rem',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...style,
  };

  return <div style={cardStyle}>{children}</div>;
});
